import { render, staticRenderFns } from "./ChatSetting.vue?vue&type=template&id=6b0a92a4&scoped=true"
import script from "./ChatSetting.vue?vue&type=script&lang=js"
export * from "./ChatSetting.vue?vue&type=script&lang=js"
import style0 from "./ChatSetting.vue?vue&type=style&index=0&id=6b0a92a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0a92a4",
  null
  
)

export default component.exports